import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20glowing%20light%20orbs%20and%20particles%20floating%20in%20dark%20space%2C%20red%20and%20amber%20energy%20waves%2C%20dramatic%20cinematic%20atmosphere%2C%20soft%20bokeh%20lights%2C%20editorial%20abstract%20background%20photography%20style&width=1600&height=700&seq=cta-bg&orientation=landscape"
          alt="CTA背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/60" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-background-50 mb-4 tracking-wide">
          加入吃瓜基地
        </h2>
        <p className="text-base md:text-lg text-background-300 mb-8 leading-relaxed">
          第一时间获取全网最新爆料资讯<br className="hidden md:block" />
          不错过任何一个精彩大瓜
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/meiri-chigua"
            className="px-8 py-3 bg-background-50 text-foreground-900 font-semibold rounded-full hover:bg-background-100 transition-colors whitespace-nowrap"
          >
            立即开始吃瓜
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 border border-background-400 text-background-200 font-semibold rounded-full hover:bg-background-50/10 transition-colors whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}